module.exports = __webpack_public_path__ + "img/ocbc.45f43bfa.png";